import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axios";

const ProfilePage = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get("/api/users/me");
                setUser(response.data);
            } catch (error) {
                console.error("Error fetching user data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    if (loading) {
        return <div className="text-center">Loading...</div>;
    }

    if (!user) {
        return <div className="text-center">No user data available.</div>;
    }

    const role = user.role === 1 ? "Administrator" : "Member";

    return (
        <div className="container mx-auto p-4 bg-white shadow-md rounded-lg">
            <h1 className="text-3xl font-semibold text-center mb-4">User Profile</h1>
            <table className="min-w-full bg-white">
                <tbody>
                    <tr>
                        <td className="px-2 py-2 font-medium">Name</td>
                        <td className="px-2 py-2">{user.name}</td>
                    </tr>
                    <tr>
                        <td className="px-2 py-2 font-medium">Email</td>
                        <td className="px-2 py-2">{user.email}</td>
                    </tr>
                    <tr>
                        <td className="px-2 py-2 font-medium">Role</td>
                        <td className="px-2 py-2">{role}</td>
                    </tr>
                    <tr>
                        <td className="px-2 py-2 font-medium">Balance</td>
                        <td className="px-2 py-2">${user.balance.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="px-2 py-2 font-medium">Address</td>
                        <td className="px-2 py-2">{user.address || "N/A"}</td>
                    </tr>
                    <tr>
                        <td className="px-2 py-2 font-medium">Preferred Payment</td>
                        <td className="px-2 py-2">{user.payment}</td>
                    </tr>
                </tbody>
            </table>

            {user.payment === 'Credit Card' && user.cards && user.cards.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-2xl font-semibold mb-4">Credit Card Information:</h3>
                    {user.cards.map((card, index) => (
                        <div key={index} className="border p-4 mb-4 rounded-lg">
                            <h4 className="font-medium">Card Type: {card.type}</h4>
                            <h4 className="font-medium">Card Number: {card.cardNumber}</h4>
                            <h4 className="font-medium">Cardholder Name: {card.holderName}</h4>
                            <h4 className="font-medium">Expiration Date: {card.expirationDate}</h4>
                            <h4 className="font-medium">CVV: {card.CVV}</h4>
                        </div>
                    ))}
                </div>
            )}

            <div className="text-center">
                <Link to="/profile/edit" className="mt-4 inline-block bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-all duration-300">
                    Edit Profile
                </Link>
            </div>
        </div>
    );
};

export default ProfilePage;
